import SimpleQuestion from "./SimpleQuestion";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector, useDispatch } from "react-redux";
import { getLanguageCode } from "../store/components";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useStylesLocally } from "../muithemeclasses";
import { useState, useEffect } from "react";
import {
  getResponseDetails,
  postCoaltionUrls,
  verifyBrokerAgainstProspect,
  getProspectDetails,
  getVerifyingBp,
} from "../store/quotes";
import { getProspectDoc } from "../store/qf";
import { getBrokerInformation } from "../store/broker";
const MultiText = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <MultiTextDropDown
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></MultiTextDropDown>
      }
    ></SimpleQuestion>
  );
};

const MultiTextDropDown = ({ node, handleAnswerChange, qfusermode }) => {
  const languagecode = useSelector(getLanguageCode);
  let brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;
  var intialState = node.answer;
  const queryParams = new URLSearchParams(window.location.search);
  const prospectid = queryParams.get("id");
  if (!Array.isArray(intialState) && intialState) {
    intialState = [intialState];
  }
  const [value, setValue] = useState(intialState || []);
  const [inputValue, setInputValue] = useState("");
  const classes = useStylesLocally();
  const gotResponseDetails = useSelector(getResponseDetails);
  const gotProspectDetails = useSelector(getProspectDoc);
  const isVerifyingBp = useSelector(getVerifyingBp);
  const dispatch = useDispatch();
  if (Object.keys(gotResponseDetails).length == 0 && !isVerifyingBp) {
    console.log("Dispatching heavy api....");
    dispatch(
      verifyBrokerAgainstProspect({
        prospectid: prospectid,
      })
    );
  }
  var coalitionResponse = false;
  var coalitionUrlBody = {};

  Object.keys(gotResponseDetails).forEach(function (key) {
    var val = gotResponseDetails[key];
    if (val.insurercode?.toLowerCase()?.includes("coalition")) {
      coalitionResponse = true;
      coalitionUrlBody.insurercode = val.insurercode;
      coalitionUrlBody.brokeragecode = gotProspectDetails?.brokeragecode;
    }
  });

  const handleAnswer = (event, value) => {
    handleAnswerChange(value);
  };

  useEffect(() => {
    if (value.length == 1) {
      handleAnswerChange(value[0]);
    } else handleAnswerChange(value);
    if (coalitionResponse) {
      coalitionUrlBody.domains = value;
      dispatch(postCoaltionUrls(coalitionUrlBody));
    }
  }, [value]);

  return (
    <Autocomplete
      multiple
      freeSolo
      //autoSelect
      id={`MultiText_${node.id}`}
      disabled={qfusermode === INSURER ? true : false}
      options={[]}
      value={value}
      inputValue={inputValue}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        const options = newInputValue.split(/,| /);
        if (options.length > 1) {
          setValue(
            value
              .concat(options)
              .map((x) => x.trim())
              .filter((x) => x)
          );
        } else {
          setInputValue(newInputValue);
        }
      }}
      getOptionLabel={(option) =>
        option.text[languagepreference] ? option.text[languagepreference] : null
      }
      classes={{
        root: classes.rootForMultiSelect,
        listbox: classes.listbox,
        input: classes.input,
        tag: classes.tag,
      }}
      renderTags={(_value, getTagProps) => {
        return _value.map((option, index) => (
          <Chip variant="outlined" label={option} {...getTagProps({ index })} />
        ));
      }}
      //onChange={handleAnswer}
      //  value={node.answer ? node.answer : []}
      renderInput={(params) => (
        <TextField
          {...params}
          classes={{
            root: classes.textFieldRootForMultiSelect,
          }}
          placeholder="Enter Text space or ,"
          fullWidth
          variant="filled"
          onFocus={() => {}}
          onBlur={() => {
            if (inputValue.trim().length > 0) {
              setValue(value.concat(inputValue.trim()));
            }
          }}
        />
      )}
    />
  );
};

export default MultiText;
